import { GetServerSidePropsContext, NextPage } from 'next';
import Meta from '../../../components/Meta';
import { metaTags } from '../../../components/_dummyData';
import { useBreadcrumbs } from '../../../components/_shared/Breadcrumbs/BreadcrumbsContext';
import type { ServicesTab } from '../../../components/Services/Services.type';
import { Service } from '../../../components/Services/Service';
import { services } from '../../../components/_dummyData/services';

const ServicePage: NextPage<
    Awaited<ReturnType<typeof getServerSideProps>>['props']
> = ({ activeTab, serviceId }) => {
    const service = services.find((s) => s.id === Number(serviceId));
    useBreadcrumbs([
        { title: 'Сервисы', href: `/services/${activeTab}` },
        { title: `Сервис "${service?.title}"` ?? 'Сервис' },
    ]);

    return (
        <>
            <Meta
                title={metaTags.services.title}
                description={metaTags.services.description}
                url={metaTags.services.url}
            />
            <Service
                serviceId={serviceId}
                service={service}
                activeTab={activeTab}
            />
        </>
    );
};

export default ServicePage;

export const getServerSideProps = async (
    context: GetServerSidePropsContext
) => {
    const serviceId = (context.query.serviceId || 1) as number;
    const activeTab = (context.query.slug ||
        'customers') as ServicesTab['name'];

    return {
        props: {
            activeTab,
            serviceId,
        },
    };
};
